import React, {
  FC, useEffect, useState,
} from 'react';
import SupportPage from './SupportPage/SupportPage';
import CheckPhone from './CheckPhone/CheckPhone';
import { getCabId, getCabId32Str } from '../../../lib/utils/utils';
import { Cab } from '../../../lib/types';

const Support: FC<Props> = ({
  cab,
  isEnglish,
  setIsEnglish,
  setShowAi,
  setTargetPage,
  // AI对话验证的手机号，每次进入都需要验证
  setAiPhoneNumber,
}) => {
  const [showCheckPhoneNumberPage, setShowCheckPhoneNumberPage] = useState(false);

  return (
    <>
      {
        !showCheckPhoneNumberPage && (
          <SupportPage
            cabId32Str={getCabId32Str(cab.cabId)}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setTargetPage={setTargetPage}
            setShowCheckPhoneNumberPage={setShowCheckPhoneNumberPage}
          />
        )
      }

      {
        showCheckPhoneNumberPage && (
          <CheckPhone
            cab={cab}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowAi={setShowAi}
            setPhoneNumber={setAiPhoneNumber}
            onClose={() => {
              setShowCheckPhoneNumberPage(false);
            }}
          />
        )
      }
    </>
  );
};

export interface Props {
  cab: Cab;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowAi: (show: boolean) => void;
  setTargetPage: (targetPage: string) => void;
  // 进入AI对话的用户手机号
  setAiPhoneNumber: (phoneNumber?: string) => void;
}

export default Support;
